import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';

import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { NotasModel } from './Notas.model';
import { NotaSaveModel } from './NotaSave.model';
import { MchNotasId } from './NotaSave.model';
import { DetalleFacturaModel } from './DetalleFactura.model';
import { OpcionModel } from '../Global/Opcion.model';
import { IfObservable } from 'rxjs/observable/IfObservable';


@Component({
	selector: 'notas',
	templateUrl: './Notas.component.html',
	styleUrls: ['../../../../styles.css']
})


export class NotasComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public tipoNota: Array<OpcionModel>;
	public patrimonios: Array<OpcionModel>;
	public prefijosFacturas: Array<OpcionModel>;
	public prefijosNotas: Array<OpcionModel>;
	public conceptoNotas: Array<OpcionModel>;
	public detalleFactura: Array<DetalleFacturaModel>;
	private notasSave: Array<NotaSaveModel>;
	filteredOptions: Observable<OpcionModel[]>;
	myControl = new FormControl();

	public form: FormGroup;
	public formErrors: any;
	public iva;
	public fechaTemporal:Date; 

	public notaModel: NotasModel;
	public nombreNegocio: string = "";
	public fechaDia:Date;
	public fechaDiaMaximaNota:Date;
	public fechaDiaHabil:Date;
	public fechaTemporalDiaHabil:any;

	public displayedColumns;
	public dataSource;

	public cnumcont: OpcionModel;

	public cargando = false;
	public botonConsultar = false;

	public ocultar: boolean = false;
	public mensaje: string = "";
	public horaPermitida: string;
	campoDeshabilitado = false;
	campoDeshabilitadoInput = false;

	constructor(private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

		this.formErrors = {


			ctipnota: {},
			cnumcont: {},
			ciddoc: {},
			cnumdoc: {},
			dfecmov: {},
			nombreNegocio: {},
			vobservacion: {},
			ncodigoconceptonota :{}

		};

		this.displayedColumns = ['cdescon', 'nvalbase', 'nvaliva', 'nimpuestoconsumo', 'nvalbaseapli', 'nvalivaapli', 'nimpuestoconsumoapli'];
		this.notaModel = new NotasModel("", "", "", "", "", 0, 0, 0, "",0,"");
		this.detalleFactura = new Array();
		this.dataSource = new ExampleDataSource(null);
		this.cnumcont = new OpcionModel('', "");
		this.snackBar.dismiss();
	}


	ngOnInit() {

		this.inicializarForm();
		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});


		this.cargarListas();

		this.filteredOptions = this.myControl.valueChanges
			.startWith(null)
			.map(val => val ? this.filter(val) : this.patrimonios.slice());

	}

	filter(val: string)//: string[]
	{
		if (val == null) {
			val = "";
		}

		let x = this.patrimonios.filter(option => (option.idOpcion.toLowerCase().trim() + option.labelOpcion.toLowerCase().trim()).indexOf(val.toLowerCase()) > -1);

		return x;
	}




	consultarPrefijos() {

		this.campoDeshabilitado = false;
		this.campoDeshabilitadoInput = false;
		this.botonConsultar = false;

		this.notaModel.cnumcont = this.cnumcont.labelOpcion.substring(0, this.cnumcont.labelOpcion.indexOf('-'));
		this.notaModel.cnumdoc = '';
		this.detalleFactura = new Array();
		this.dataSource = new ExampleDataSource(null);

		let c = 0
		for (let x in this.patrimonios) {
			if (this.patrimonios[x].idOpcion == this.notaModel.cnumcont && c == 0) {
				this.nombreNegocio = this.patrimonios[x].labelOpcion;
				c = 1;
			}
		}
		if (c == 0)
			this.nombreNegocio = "";


		this.prefijosFacturas = new Array();
		this.prefijosNotas = new Array();

		this._serviciosGenerales.get('listaPrefijosContrato', { cnumcont: this.notaModel.cnumcont }).subscribe(
			result => {
				for (let x of result) {
					this.prefijosFacturas.push(new OpcionModel(x.cprefijo.trim(), x.cprefijo.trim()));
				};
				if (this.prefijosFacturas.length == 0) {
					this.openSnackBarEspecial("No se encontraron prefijos para el contrato: " + this.notaModel.cnumcont, "X");
				} else {
					this.snackBar.dismiss();
				}
			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos", "X");
			});


	}

	cargarPrefijosNotas() {
		this.prefijosNotas = new Array();

		this._serviciosGenerales.get('tipoFactura', { cnumcont: this.notaModel.cnumcont, ciddoc: this.notaModel.ciddoc }).subscribe(
			result => {
				if (result[0].tipo == 7) {
					this._serviciosGenerales.get('listaPrefijosNotas', { cnumcont: this.notaModel.cnumcont, ciddoc: this.notaModel.ciddoc }).subscribe(
						result => {
							for (let x of result) {
								this.prefijosNotas.push(new OpcionModel(x.cprefijo.trim() + '*' + x.csigno, x.cprefijo.trim()));
							};
							if (this.prefijosNotas.length == 0)
								this.openSnackBarEspecial("No se encontraron prefijos de notas", "X");
							else
								this.snackBar.dismiss();
						}, error => {
							var errorMensaje = <any>error;
							console.log('Error al enviar la peticion ', errorMensaje);
							this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos de notas", "X");
						});
				}
				else {
					this._serviciosGenerales.get('listaPrefijosNotasFacturasNormal', { cnumcont: this.notaModel.cnumcont, ciddoc: this.notaModel.ciddoc }).subscribe(
						result => {
							for (let x of result) {
								this.prefijosNotas.push(new OpcionModel(x.cprefijo.trim() + '*' + x.csigno, x.cprefijo.trim()));
							};
							if (this.prefijosNotas.length == 0)
								this.openSnackBarEspecial("No se encontraron prefijos de notas", "X");
							else
								this.snackBar.dismiss();
						}, error => {
							var errorMensaje = <any>error;
							console.log('Error al enviar la peticion ', errorMensaje);
							this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos de notas", "X");
						});
				}
			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los prefijos de notas", "X");
			});
	}

	consultarConceptoNota(){

		this.conceptoNotas = new Array();
		
		this._serviciosGenerales.get('listaConceptosNotas', { nota:this.notaModel.ctipnota.substr(0, this.notaModel.ctipnota.indexOf('*')).trim(),cnumcont:this.notaModel.cnumcont}).subscribe(
			result => {
				for (let x in result) {
					//console.log(result[x].ncodigo,"===========",result[x].descripcion.trim());
					this.conceptoNotas.push(new OpcionModel(result[x].ncodigo, result[x].descripcion.trim()));
				}
				this.cargando = false;
			},
			error => {
				var errorMensaje = <any>error;
				//console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los conceptos de las notas", "X");
				this.cargando = false;
			}
		)
	}


	consultarFactura() {
		this.botonConsultar = true;
		this.cargando = true;
		this.detalleFactura = new Array();
		this._serviciosGenerales.get('listadoDetalleFactura', { cnumcont: this.notaModel.cnumcont, ciddoc: this.notaModel.ciddoc, cnumdoc: this.notaModel.cnumdoc }).subscribe(
			result => {
				this.detalleFactura = new Array();

				for (let x in result) {
					console.log("porcentaje====>",result[x].nporcentaje);
					this.detalleFactura.push(new DetalleFacturaModel(result[x].cdescon, result[x].ccodcon, result[x].nvalbase, result[x].nvaliva, result[x].nimpuestoconsumo, result[x].nvalbase, result[x].nvaliva, result[x].nimpuestoconsumoapli, result[x].nidreg, result[x].nregconcep, result[x].dfecmov, result[x].unidades,result[x].nporcentaje,result[x].ndescuento ));
				};

				if(this.detalleFactura.length == 0){
					this.botonConsultar = false;
					this.cargando = false;
					this.openSnackBarEspecial("No se ha encontrado la factura", "X");
					this.campoDeshabilitado = false;
				    this.campoDeshabilitadoInput = false;
				}
				if(this.detalleFactura.length > 0){
					this.dataSource = new ExampleDataSource(this.detalleFactura);
					this.cargarPrefijosNotas();
					this.cargando = false;
					this.campoDeshabilitado = true;
				    this.campoDeshabilitadoInput = true;
				}


			}, error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar el detalle de la factura", "X");
				this.cargando = false;
			});

			this._serviciosGenerales.get('consultaCobroIva', { cnumcont: this.notaModel.cnumcont }).subscribe(
				result => {
					for (let x of result) {
						this.iva = { ntipo: x.ntipo, nvalor: x.nvalor };
						console.log(this.iva);
					}
				},
				error => {
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
				});
	}

	private cargarListas() {
		this.patrimonios = new Array();
		this.cargando = true;
		this._serviciosGenerales.get('listaPatrimonios', { param: 0 }).subscribe(
			result => {
				for (let x in result) {
					this.patrimonios.push(new OpcionModel(result[x].cnumcont.trim(), result[x].vnombrenegocio.trim()));
				}
				this.cargando = false;
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los patrimonios", "X");
				this.cargando = false;
			}
		)

		this._serviciosGenerales.get('fechaSistemaDiaHabil', {param: 0 }).subscribe(result => {
			console.log("----->----------<------------>-----------> ",result);
			this.fechaDiaHabil = result[0].DIAHABIL;
			this.fechaTemporalDiaHabil = this.fechaDiaHabil;  
			console.log("----->----------",this.fechaDiaHabil);
		}, error => {
			var errorMensaje = <any>error;
			console.log('Error al enviar la peticion ', errorMensaje);
			this.openSnackBarEspecial("Ocurrió un error al momento de consultar el día habil", "X");
			this.cargando = false;
		})

		this._serviciosGenerales.get('horaPermitida', {}).subscribe(res => {
			console.log("/////////////////////// ",res);
			this.horaPermitida = res[0].CVALOR;
			console.log('====>'+this.horaPermitida);
		}, error => {
			this.ocultar = true;
			this.mensaje = "Procesando Información ..";

			this.openSnackBarEspecial("Ocurrió un error al momento de consultar el horario Permitido a Facturar","X");
			console.log(error, '');
		})



	}

	cambioPrefijo() {
		this.notaModel.ctipnota = '';
		this.prefijosNotas = [];
		//console.log('Evento cambio prefijos');
		this.cargando = true;
		this.cargarPrefijosNotas(); 
		this.cargando = false;
	  }

	fechasistema(){
        this._serviciosGenerales.get('fechaSistema', {param: 0 }).subscribe(res => {
            console.log("----->----------<------------>-----------> ",res);
            this.fechaDia = res[0].FECHADIA;
            this.fechaTemporal = this.fechaDia;  
        }, error => {
            
            this.ocultar = true;
            this.mensaje = "Procesando Información ..";
            
            this.openSnackBarEspecial("Ocurrió un error al momento de consultar la fecha del Día","X");
            console.log(error, '');
        })
	}



	cambiarBoton() {
		this.cargando = true;
		this.botonConsultar = true;
		this.consultarFactura();
	}


	calcularValorIVA(registro){
		//var position = this.dataSource.data.indexOf(registro);
		//console.log("michaelllllllllllllllllllll====>",registro.nvalbaseapli,'---',registro.nporcentaje,'---------');
		if (this.iva.ntipo == 1) {
			registro.nvalivaapli=((registro.nvalbaseapli*registro.nporcentaje)/100)
		}
		if (this.iva.ntipo == 3){
			if (registro.nvalbaseapli>this.iva.nvalor){
				registro.nvalivaapli=((registro.nvalbaseapli*registro.nporcentaje)/100)
			}
		}
		if (this.iva.ntipo == 4){
			registro.nvalivaapli=((registro.nvalbaseapli*this.iva.nvalor)/100)
		}

	}

	guardar() {

		let date = new Date();
		console.log(date.getHours()); // hora actual
		console.log(date.getMinutes()); // minutos actuales
 		let horaTemporal =date.getHours()+':'+date.getMinutes();


		if (this.form.valid == false) {
			this.openSnackBarEspecial('Hay Campos requeridos sin llenar', 'X');
			return;
		}

		const existe = this.prefijosNotas.some(el => el.idOpcion === this.notaModel.ctipnota);

		if (existe == false) {
			this.openSnackBarEspecial('El prefijo de la nota no es correcto', 'X');
			return;
		}		

		let mensajes = "";
		let resta = (this.notaModel.ctipnota.indexOf('-') > -1);
		for (let x in this.detalleFactura) {
			console.log(this.detalleFactura[x]);
			if (resta == true) {
				if (this.detalleFactura[x].nvalbase < this.detalleFactura[x].nvalbaseapli) {
					this.openSnackBarEspecial('El valor Base a aplicar: ' + this.detalleFactura[x].nvalbaseapli + ' es mayor al valor base original: ' + this.detalleFactura[x].nvalbase + ' para el concepto: ' + this.detalleFactura[x].cdescon, 'X');
					return;
				}
				if (this.detalleFactura[x].nvaliva < this.detalleFactura[x].nvalivaapli) {
					this.openSnackBarEspecial('El valor Iva a aplicar: ' + this.detalleFactura[x].nvalivaapli + ' es mayor al valor Iva original: ' + this.detalleFactura[x].nvaliva + ' para el concepto: ' + this.detalleFactura[x].cdescon, 'X');
					return;
				}
				if (this.detalleFactura[x].nimpuestoconsumo < this.detalleFactura[x].nimpuestoconsumoapli) {
					this.openSnackBarEspecial('El valor Impuesto Consumo a aplicar: ' + this.detalleFactura[x].nimpuestoconsumoapli + ' es mayor al valor Impuesto Consumo original: ' + this.detalleFactura[x].nimpuestoconsumo + ' para el concepto: ' + this.detalleFactura[x].cdescon, 'X');
					return;
				}
				if (new Date(this.notaModel.dfecmov).getTime() < new Date(this.detalleFactura[x].dfecmov).getTime()) {
					this.openSnackBarEspecial('No se puede aplicar la Nota ya que la fecha: (' + new Date(this.notaModel.dfecmov).toISOString().substr(0, 10) + ') No puede ser inferior a la fecha de la Factura (' + new Date(this.detalleFactura[x].dfecmov).toISOString().substr(0, 10) + ') para el concepto: ' + this.detalleFactura[x].cdescon, 'X');
					return;
				}
			}
			else {
				if (new Date(this.notaModel.dfecmov).getTime() < new Date(this.detalleFactura[x].dfecmov).getTime()) {
					this.openSnackBarEspecial('No se puede aplicar la Nota ya que la fecha: (' + new Date(this.notaModel.dfecmov).toISOString().substr(0, 10) + ') No puede ser inferior a la fecha de la Factura (' + new Date(this.detalleFactura[x].dfecmov).toISOString().substr(0, 10) + ') para el concepto: ' + this.detalleFactura[x].cdescon, 'X');
					return;
				}
			}
			if (this.detalleFactura[x].ndescuento>0  && this.notaModel.ctipnota.toString().endsWith('*+') ) {
				this.openSnackBarEspecial('Nota no aceptada', 'X');
				return;
			}
		}

		this.fechasistema();
        let fechaAct =  new Date(this.notaModel.dfecmov);
        let fechaControl = new Date(this.fechaTemporal);
        fechaAct.setHours(0,0,0,0);
        fechaControl.setHours(0,0,0,0);
    

		this.cargando = true;

		var d = new Date();
		let n: string = String(d.getTime());
		this.notasSave = new Array();
		for (let x in this.detalleFactura) {
			if (this.detalleFactura[x].nvalbaseapli > 0 || this.detalleFactura[x].nvalivaapli > 0 || this.detalleFactura[x].nimpuestoconsumoapli > 0) {
				if (this.detalleFactura[x].nvalbaseapli == null)
					this.detalleFactura[x].nvalbaseapli = 0;
				if (this.detalleFactura[x].nvalivaapli == null)
					this.detalleFactura[x].nvalivaapli = 0;
				if (this.detalleFactura[x].nimpuestoconsumoapli == null)
					this.detalleFactura[x].nimpuestoconsumoapli = 0;

				this.notasSave.push(new NotaSaveModel(new MchNotasId(n, this.detalleFactura[x].ccodcon, this.detalleFactura[x].nregconcep), this.notaModel.cnumcont,
					this.notaModel.ciddoc, this.notaModel.cnumdoc,
					this.notaModel.ctipnota.substr(0, this.notaModel.ctipnota.indexOf('*')).trim(),
					this.notaModel.dfecmov,
					this.detalleFactura[x].nvalbaseapli, this.detalleFactura[x].nvalivaapli, this.detalleFactura[x].nidreg, this.detalleFactura[x].nimpuestoconsumoapli, this._serviciosGenerales.seguridad.getInfoSesion().usuario, this.notaModel.vobservacion, this.detalleFactura[x].unidades,this.notaModel.ncodigoconceptonota));
			}
		}


		if (this.notasSave.length == 0) {
			this.openSnackBarEspecial('No se encontraron valores mayores a 0 para aplicar', 'X');
			this.cargando = false;
			return;
		}
		
		
				this._serviciosGenerales.post('guardar/nota', this.notasSave).subscribe(
					result => {

						if (result.error == true) {
							this.openSnackBarEspecial(result.mensaje, "X");
							this.cargando = false;
							return;
						}

						let parametros = { CID: n };
						this._serviciosGenerales.get('procedure/APLICAR_NOTAS', parametros).subscribe(
							result => {
								console.log(result);

								if (result.error == true || result.mensaje.toUpperCase().indexOf('OK') == -1) {
									this.openSnackBarEspecial(result.mensaje, "X");
									this.cargando = false;
									return;
								} else {
									this.openSnackBar('Nota aplicada correctamente '+result.mensaje.replace('OK',''), "X");
									this.form.reset();
									this.form.clearAsyncValidators();
									this.form.clearValidators();
									this.inicializarForm();
									this.detalleFactura = new Array();
									this.notaModel = new NotasModel("", "", "", "", "", 0, 0, 0, "",0,"");
									this.botonConsultar = false;
								}
								this.cargando = false;
							}, error => {
								var errorMensaje = <any>error;
								console.log('Error al enviar la peticion ', errorMensaje);
								this.openSnackBarEspecial("No se logró obtener la respuesta del servidor, por favor verificar si se efectuó este proceso.", "X");
								this.cargando = false;
							})
					}, error => {
						var errorMensaje = <any>error;
						console.log('Error al enviar la peticion ', errorMensaje);
						this.openSnackBarEspecial("Ocurrió un error al momento de guardar la información", "X");
						this.cargando = false;
					});		
	}

	private inicializarForm() {
		this.form = this.formBuilder.group({
			ctipnota: ['', Validators.required],
			cnumcont: ['', Validators.required],
			ciddoc: ['', Validators.required],
			cnumdoc: ['', Validators.required],
			//dfecmov: ['', Validators.required],
			nombreNegocio: [{ value: '', disabled: true }],
			vobservacion: ['', Validators.required],
			ncodigoconceptonota: ['', Validators.required],
		});

	}

	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});

	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}


}


export class ExampleDataSource {

	public data: Array<DetalleFacturaModel>;


	constructor(sucursal: Array<DetalleFacturaModel>) {
		this.data = new Array();


		if (sucursal != null) {
			for (let i of sucursal) {
				this.data.push(i);
			}
		}
	}

	/** Connect function called by the table to retrieve one stream containing the data to render. */
	connect(): Observable<DetalleFacturaModel[]> {
		return Observable.of(this.data);
	}

	disconnect() {
	}

}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Notas/Notas.component.ts